/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


    jQuery('.cstm-filter-main').on('click',function(){
      if(jQuery(window).width() >= 641){
      var aria = jQuery(this).attr('aria-expanded');
      if(aria=='false'){
        jQuery(this).next('.Collapsible__Inner').slideDown();
        jQuery(this).attr('aria-expanded','true');
      }
      if(aria=='true'){
        jQuery(this).next('.Collapsible__Inner').slideUp();
        jQuery(this).attr('aria-expanded','false');
      }
      }
    });


if (jQuery(window).width() < 768) {
  jQuery(window).scroll(function() {  

    var scroll = $(window).scrollTop();

    //>=, not <=
    if (scroll >= 1200) {
      //clearHeader, not clearheader - caps H
      jQuery(".cstm-atc-btn").addClass("darkHeader");  
    }
    else{
      jQuery(".cstm-atc-btn").removeClass("darkHeader"); 
    }
  });
}



if (jQuery(window).width() < 1008) {
  jQuery(window).scroll(function() {  

    var scroll = $(window).scrollTop();

    //>=, not <=
    if (scroll >= 320) {
      //clearHeader, not clearheader - caps H
      jQuery(" .cstm-sticky-filter").addClass("cstmstickfiletr");  
    }
    else{
      jQuery(" .cstm-sticky-filter").removeClass("cstmstickfiletr"); 
    }
  });
}


if (jQuery(window).width() < 767) {
   $(".titles").click(function() {
    $('html, body').animate({
        scrollTop: $("#shop-the-look").offset().top - 250
    }, 2000);
});
}


$(".shoplookslider").flickity({
   prevNextButtons: true,
      initialIndex: 2,
      pageDots: false,
  
    });



// $(".shoplookslider").owlCarousel({
//   autoplay: true,
//   lazyLoad: true,
//   loop: true,
//   margin: 20,
//   responsive: {
//     0: {
//       items: 1
//     },

//     600: {
//       items: 3
//     },

//     1024: {
//       items: 4
//     },

//     1366: {
//       items: 4
//     }
//   }
// });







